// extracted by mini-css-extract-plugin
export default {"headerBar":"CN-z","pointsSection":"DN-z","goToDashboard":"EN-z"};